<body>
  <div class="main">
    <div class="grid-overlay">
      <div class="nav">
      </div>
      <div class="logoblock">
        <img (click)="goLogin()" src="../../assets/images/BRAND.png" alt="Logo Billcentrix">
        <!-- título dinámico -->
        @if (!modoSeleccionPortal) {
          <h2>{{ 'validatePin.title' | translate }}</h2>
        }
        @if (modoSeleccionPortal) {
          <h2>{{ 'validatePin.selectCompany' | translate }}</h2>
        }
      </div>

      <!-- 🔑 Formulario de validación PIN (solo cuando NO es admin Y NO viene de passkey) -->
      @if (!modoSeleccionPortal && !hideValidationForm) {
        <div class="background-white">
          <h1>{{ 'validatePin.title' | translate }}</h1>
          <!-- Estado de carga inicial -->
          @if (isCheckingPasskey) {
            <div class="checking-passkey-state">
              <mat-spinner diameter="40"></mat-spinner>
              <p>{{ 'validatePin.loading' | translate }}</p>
            </div>
          }
          <!-- Contenido principal (solo se muestra después de verificar) -->
          @if (!isCheckingPasskey) {
            <div>
              <!-- ============================================ -->
              <!-- VISTA DE PASSKEY (cuando activeMethod === 'passkey' y tiene passkey) -->
              <!-- ============================================ -->
              @if (showPasskeyOption && activeMethod === 'passkey') {
                <div class="passkey-view">
                  <div class="passkey-section">
                    <div class="passkey-header">
                      <mat-icon class="passkey-icon">fingerprint</mat-icon>
                      <h3>{{ 'validatePin.passkey.title' | translate }}</h3>
                      <p>{{ 'validatePin.passkey.description' | translate:{ method: biometricMethodName } }}</p>
                    </div>
                    <button
                      type="button"
                      class="btn-passkey"
                      (click)="validateWithPasskey()"
                      [disabled]="isLoadingPasskey"
                      [matTooltip]="'validatePin.passkey.tooltip' | translate:{ method: biometricMethodName }"
                      matTooltipPosition="above">
                      <mat-icon>fingerprint</mat-icon>
                      @if (!isLoadingPasskey) {
                        <span>
                          {{ 'validatePin.passkey.button' | translate:{ method: biometricMethodName } }}
                        </span>
                      }
                      @if (isLoadingPasskey) {
                        <span>
                          {{ 'validatePin.passkey.verifying' | translate }}
                        </span>
                      }
                    </button>
                    @if (passkeyError) {
                      <div class="alert-error">
                        <mat-icon>error_outline</mat-icon>
                        <span>{{ passkeyError }}</span>
                      </div>
                    }
                  </div>
                  <!-- Botón para cambiar a PIN -->
                  <div class="switch-method-section">
                    <p class="switch-text">{{ 'validatePin.passkey.switchInfo' | translate }}</p>
                    <button type="button" class="btn-switch-method" (click)="switchToPinMethod()">
                      <mat-icon>email</mat-icon>
                      <span>{{ 'validatePin.passkey.switchButton' | translate }}</span>
                    </button>
                  </div>
                </div>
              }
              <!-- ============================================ -->
              <!-- VISTA DE PIN (cuando activeMethod === 'pin' o no tiene passkey) -->
              <!-- ============================================ -->
              @if (showPinForm) {
                <div class="pin-view">
                  <!-- Texto informativo -->
                  @if (pinWasSent) {
                    <p class="info-text">
                      {{ 'validatePin.pin.infoText' | translate }}
                    </p>
                  }
                  <form class="user" [formGroup]="validateForm" (ngSubmit)="validate()" >
                    <div class="pin-input-container">
                      <input
                        [formControl]="validateForm.controls['pin']"
                        [type]="showPin ? 'text' : 'password'"
                        class="form-control form-control-user"
                        id="pinInput"
                        [placeholder]="'validatePin.pin.placeholder' | translate"
                        maxlength="8"
                        aria-describedby="pinHelp">
                        <button
                          type="button"
                          class="toggle-pin-btn"
                          (click)="toggleShowPin()"
                          tabindex="-1"
                          aria-label="Mostrar/ocultar PIN">
                          <img [src]="showPin ? 'assets/icons/ver.png' : 'assets/icons/ver.png'" alt="Toggle visibility" class="toggle-pin-img">
                        </button>
                      </div>
                      @if (validateForm.controls['pin'].hasError('required') && validateForm.controls['pin'].touched) {
                        <small
                        class="form-error-msg">{{ 'validatePin.pin.required' | translate }}</small>
                      }
                      <!-- Mensaje de ayuda con intentos restantes -->
                      @if (helpMessage) {
                        <div class="help-message">
                          <p class="warning-text">⚠️ {{helpMessage}}</p>
                        </div>
                      }
                      <div class="options">
                        <button class="crear" type="submit" [disabled]="validateForm.invalid || isSubmittingPin || isResendingPin">{{ 'validatePin.pin.submit' | translate }}</button>
                      </div>
                      <div class="transparent-background">
                        <p>{{ 'validatePin.pin.notReceived' | translate }}</p>
                        <a (click)="!isResendingPin && !isSubmittingPin && resendPin()" class="resend-link" [attr.aria-disabled]="isResendingPin || isSubmittingPin">{{ 'validatePin.pin.resend' | translate }}</a>
                      </div>
                    </form>
                    <!-- Botón para volver a Passkey (solo si tiene passkey y está en modo PIN) -->
                    @if (showPasskeyOption && activeMethod === 'pin') {
                      <div class="switch-method-section">
                        <button type="button" class="btn-switch-method-secondary" (click)="switchToPasskeyMethod()">
                          <mat-icon>fingerprint</mat-icon>
                          <span>{{ 'validatePin.passkey.backToPasskey' | translate }}</span>
                        </button>
                      </div>
                    }
                  </div>
                }
                @if (passkeyAvailabilityState === 'error' && !pinExplicitlySelected) {
                  <div class="passkey-error-state">
                    <p>No pudimos consultar la passkey. Elige cómo continuar.</p>
                    <button type="button" class="btn-switch-method" (click)="retryPasskeyLookup()">
                      <mat-icon>refresh</mat-icon>
                      <span>Reintentar</span>
                    </button>
                    <button type="button" class="btn-switch-method" (click)="switchToPinMethod()">
                      <mat-icon>email</mat-icon>
                      <span>{{ 'validatePin.passkey.switchButton' | translate }}</span>
                    </button>
                  </div>
                }
                <!-- Botón para volver al login (siempre visible) -->
                <div class="back-to-login">
                  <button type="button" (click)="goLogin()" class="back-login-btn">
                    {{ 'validatePin.backToLogin' | translate }}
                  </button>
                </div>
              </div>
            }
          </div>
        }

        <!-- 🟢 Selección de portales (cuando es admin) -->
        @if (modoSeleccionPortal) {
          <app-select-portal
            [portals]="portals"
          ></app-select-portal>
        }
      </div>

    </div>

    <!-- Modal de Onboarding de Passkey -->
    @if (showOnboardingModal) {
      <app-passkey-onboarding-modal
        (close)="onOnboardingModalClose($event)">
      </app-passkey-onboarding-modal>
    }

    <app-footer></app-footer>
